<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('esl_reports')" :is-filter="false">
        </Header>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('esl_reports')" :is-filter="false">
        </HeaderMobile>
      </template>
      <div class="row data-form">
        <div class="col-12">
          <ValidationObserver ref="form">
            <div class="row">
              <div class="col-12 col-sm-6">
                <ValidationProvider name="report" rules="required" v-slot="{valid, errors}">
                  <b-form-group :label="$t('report')">
                    <multi-selectbox :allow-empty="false" :multiple="false"
                                     :validate-error="errors[0]" :options="reportOptions"
                                     v-model="form.report"></multi-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-12 col-sm-6">
                <ValidationProvider name="response_type" rules="required" v-slot="{valid, errors}">
                  <b-form-group :label="$t('report_type')">
                    <multi-selectbox :allow-empty="false"
                                     :multiple="false"
                                     :disabled="responseTypeDisabled"
                                     :validate-error="errors[0]"
                                     :options="responseTypeOptions"
                                     v-model="form.response_type"></multi-selectbox>
                  </b-form-group>
                </ValidationProvider>
              </div>
              <div class="col-12">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4 mb-3"
                       v-if="['3','5','8','10','11','13','14','27'].includes(form.report)">
                    <ValidationProvider name="number"
                                        :rules="['3','5','8','10','11', '13','14','27'].includes(form.report) ? 'required' : ''"
                                        v-slot="{ valid, errors }">
                      <b-form-group :label="$t('start_date') + ' - '+ $t('end_date')" class="mb-0">
                        <v-date-picker v-model="form.date" is-range locale="en">
                          <template v-slot="{ inputValue, inputEvents }">
                            <div class="d-flex align-items-center">
                              <div class="flex-grow-1 mr-1">
                                <b-form-group class="m-0">
                                  <input
                                      :value="inputValue.start"
                                      v-on="inputEvents.start"
                                      :placeholder="$t('start_date')"
                                      class="form-control"
                                  />
                                </b-form-group>
                              </div>
                              <div class="flex-grow-1 ml-1">
                                <b-form-group class="m-0">
                                  <input
                                      :value="inputValue.end"
                                      v-on="inputEvents.end"
                                      :placeholder="$t('end_date')"
                                      class="form-control"
                                  />
                                </b-form-group>
                              </div>
                            </div>
                          </template>
                        </v-date-picker>
                      </b-form-group>
                      <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-sm-6" v-if="['16','2','15', '32'].includes(form.report)">
                    <ValidationProvider
                        name="academic_year"
                        :rules="['16'].includes(form.report) ? 'required' : ''"
                        v-slot="{ valid, errors }"
                    >
                      <b-form-group :label="$t('academic_year')">
                        <academic-years-selectbox
                            v-model="form.academic_year"
                            :validate-error="errors[0]"
                        ></academic-years-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-12 col-sm-6" v-if="['10'].includes(form.report)">
                    <ValidationProvider name="level_id" rules="" v-slot="{valid, errors}">
                      <b-form-group :label="$t('level')">
                        <multi-selectbox :allow-empty="false" :multiple="false"
                                         :validate-error="errors[0]" :options="passFailDataByAssessmentOptions"
                                         v-model="form.level_id"></multi-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-6" v-if="['4','6','9','12'].includes(form.report)">
                    <ValidationProvider
                        name="year"
                        :rules="['4','6','9','12'].includes(form.year) ? 'required' : ''"
                        v-slot="{ valid, errors }"
                    >
                      <b-form-group :label="$t('year')">
                        <YearSelectBox
                            v-model="form.year"
                            :validate-error="errors[0]"
                        ></YearSelectBox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 col-md-4 mb-3 d-flex flex-column justify-content-center mt-5"
                       v-if="completed||student_list">
                    <b-form-checkbox v-model="form.completed" v-if="completed">
                      {{ $t('completed') }}
                    </b-form-checkbox>
                    <b-form-checkbox v-model="form.student_list" v-if="student_list">
                      {{ $t('student_list') }}
                    </b-form-checkbox>
                  </div>
                  <div class="col-2" v-if="['13'].includes(form.report)">
                    <ValidationProvider name="student_status" rules="" v-slot="{ valid, errors }">
                      <b-form-group :label="$t('student_status')">
                        <parameter-selectbox v-model="form.student_status" code="student_statuses"
                                             :filterOtherUrl="true"
                                             filterName="transfer"
                                             :is-cache="false"
                                             student-type="bau"
                                             :filter-other-url="true"
                                             :validateError="errors[0]"/>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-2" v-if="['14'].includes(form.report)">
                    <ValidationProvider name="payment_type_id" rules="" v-slot="{valid, errors}">
                      <b-form-group :label="$t('payment_type')">
                        <payment-types-selectbox :validate-error="errors[0]"
                                                 v-model="form.payment_type_id">
                        </payment-types-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>

                  <div class="col-6" v-if="['7','15','16','17','18','1','2','20','22','23','24','25','26','28','29', '30', '31', '32'].includes(form.report)">
                    <ValidationProvider name="module_date_id"
                                        :rules="['7','17','1','2','20','22','23','24','25','26','28','29', '30','31','32'].includes(form.report)?'required':''"
                                        v-slot="{valid, errors}">
                      <b-form-group :label="$t('module_date')">
                        <module-date-selectbox :validate-error="errors[0]" v-model="form.module_date_id" :academic_year="form.academic_year" :multiple="['15','29'].includes(form.report)">
                        </module-date-selectbox>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                  <processing-button @click="send" label="get_report"
                                     :processing="processing"></processing-button>
                </div>
              </div>

            </div>
          </ValidationObserver>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout"
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import {ValidationObserver, ValidationProvider} from "vee-validate";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox";
import ProcessingButton from "@/components/elements/ProcessingButton";

import {reports as reportData} from '@/modules/eslReports/data/data.js';
import EslReportService from "@/services/EslReportService";
import moment from "moment";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import YearSelectBox from "@/components/interactive-fields/YearSelectBox.vue";
import qs from "qs";
import PaymentTypesSelectbox from "@/components/interactive-fields/PaymentTypesSelectbox.vue";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";

export default {
  components: {
    PaymentTypesSelectbox,
    YearSelectBox,
    AcademicYearsSelectbox,
    ProcessingButton,
    MultiSelectbox,
    AppLayout,
    ValidationProvider,
    ValidationObserver,
    Header,
    HeaderMobile,
    ModuleDateSelectbox
  },
  metaInfo() {
    return {
      title: this.$t('esl_reports')
    }
  },
  data() {
    return {
       responseTypeDisabled:false,
      form: {
        response_type: 'excel'
      },
      responseTypeOptions: [
        {value: 'page', text: this.$t('page')},
        {value: 'excel', text: this.$t('excel')},
        {value: 'pdf', text: 'PDF'},
      ],
      studentTimeOfOptions: [
        {
          text: 'Time Off',
          value: 'Time Off',
        },
        {
          text: 'Out of Country',
          value: 'Out of Country',
        }
      ],
      passFailDataByAssessmentOptions: [],
      processing: false,
      reportName: "",
      start_date_end_date: false,
      completed: false,
      student_list: false
    }
  },
  computed: {
    reportOptions() {
      return reportData.filter((item) => {
        return this.checkPermission(item.permission)
      })
    },
  },
  methods: {
    async send() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.processing = true;
        this.reportName = this.getOptionText(this.reportOptions, this.form.report);
        let config = {params: this.form};
        let isArrayBuffer = false;
        if (this.form.response_type != 'page') {
          config.responseType = 'arraybuffer';
          isArrayBuffer = true;
        }
        if (this.form.report == '1') {
          config.params.module_date_id = this.form.module_date_id;
          EslReportService.eslAttendanceReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '2') {
          EslReportService.numberOfStudents(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '3') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.conditionalPass(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '4') {
          EslReportService.passFailReport(config, this.form.year).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '5') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.passFailDataBySession(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '6') {
          EslReportService.genderReport(config, this.form.year).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '7') {
          // config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          // config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.studentTimeOf(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '8') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.eslReportsAchievementScale(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '9') {
          EslReportService.passFailRateDataByLevel(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '10') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.passFailDataByAssessment(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '11') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.countryReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '12') {
          EslReportService.visaTypeReportForYear(config, this.form.year).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '13') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.getTransferOut(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '14') {
          config.params.start_date = moment(config.params.date.start).format('MM/DD/YYYY');
          config.params.end_date = moment(config.params.date.end).format('MM/DD/YYYY');
          EslReportService.receivedPaymentsReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '15') {
          config.params.academic_year = this.form.academic_year;
          config.params.module_date_id = this.form.module_date_id;
          EslReportService.paymentDetailReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '16') {
          EslReportService.mentoraSevisRegistrationReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '17') {
          EslReportService.rosterReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '18') {
          EslReportService.previewRosterReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '19') {
          EslReportService.MediaOptOutReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '20') {
          EslReportService.mentoraCurrentStudentsNotRegistretedReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '21') {
          EslReportService.terminationCompletion(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '22') {
          EslReportService.reportsStudentCourseRegistration(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '23') {
          EslReportService.missingEnrollmentAgreementReport(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '24') {
          EslReportService.level600ClassAssignment(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        } else if (this.form.report == '25') {
          EslReportService.level100and500ClassAssignment(config).then(this.callback).catch(e => {
            this.showErrors(e, this.$refs.form, isArrayBuffer);
          }).finally(() => {
            this.processing = false;
          });
        }else if (this.form.report == '26') {
            const filter={
                params:{
                    filter:{
                        module_date_id:config.params.module_date_id
                    },
                    response_type: config.params.response_type,
                },
                responseType:config.responseType,

                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            EslReportService.collectionReport(filter).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        }else if (this.form.report == '27') {
            const filter={
                params:{
                  start_date: moment(this.form.date.start).format('MM/DD/YYYY'),
                  end_date: moment(this.form.date.end).format('MM/DD/YYYY'),
                  response_type: config.params.response_type
                },
                responseType:config.responseType,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            EslReportService.bank_reconciliation(filter).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        }else if (this.form.report == '28') {
            EslReportService.AttendanceEntryTracking(config).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        }else if (this.form.report == '29') {
            EslReportService.agencyReport(config).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        }else if (this.form.report == '30') {
            EslReportService.historyModuleReport(config).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        } else if (this.form.report == '31') {
            config.params.module_date_id = this.form.module_date_id;
            EslReportService.moduleStudentList(config).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        } else if (this.form.report == '32') {
            config.params.academic_year = this.form.academic_year;
            config.params.module_date_id = this.form.module_date_id;
            EslReportService.moduleEnrollmentComparison(config).then(this.callback).catch(e => {
                this.showErrors(e, this.$refs.form, isArrayBuffer);
            }).finally(() => {
                this.processing = false;
            });
        }
      }
    },
    callback(response) {
      if (this.form.response_type == 'page') {
        this._openFile(response);
      } else if (this.form.response_type == 'excel') {
        this._downloadFile(response, this.reportName + '.xlsx');
      } else if (this.form.response_type == 'pdf') {
        this._downloadFile(response, this.reportName + '.pdf');
      }
    },
    getPassFailDataByAssessment(value) {
      this.passFailDataByAssessmentOptions = []
      const config = {
        params: {
          start_date: moment(value.start).format('MM/DD/YYYY'),
          end_date: moment(value.end).format('MM/DD/YYYY')
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),

      }
      EslReportService.getPassFailDataByAssessmentOptions(config)
          .then(res => {
            const data = res.data.data;
            if (Object.entries(data).length > 0) {
              Object.entries(data).forEach(([key, value]) => {
                this.passFailDataByAssessmentOptions.push({
                  text: value,
                  value: key
                })
              })
            }

          }).catch(err => {
        this.showErrors(err)
      })

    }
  },
  watch: {
    'form.report'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.form = {response_type: 'excel', report: newVal}
      }
      this.start_date_end_date = false;
      this.completed = false
      this.student_list = false
      if (newVal === '3' || newVal === '5' || newVal === '8') {
        this.start_date_end_date = true;
      }
      else if (['26'].includes(newVal)) {
            this.form = {...this.form, response_type: 'excel'}
            this.responseTypeDisabled=true
      }else {
          this.responseTypeDisabled=false
      }
    },
    'form.response_type'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form = {...this.form, response_type: newVal}
      }

    },
    'form.date'(newVal, oldVal) {
      if (newVal !== oldVal && this.form.report === "10") {
        this.getPassFailDataByAssessment(newVal)
      }
    }
  },

};
</script>

